import { render, staticRenderFns } from "./PagamentoGrid.vue?vue&type=template&id=1c2425bb"
import script from "./PagamentoGrid.vue?vue&type=script&lang=js"
export * from "./PagamentoGrid.vue?vue&type=script&lang=js"
import style0 from "./PagamentoGrid.vue?vue&type=style&index=0&id=1c2425bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports